import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const filterUsefulDocuments = (query, documentLinks) => {
    const searchStr = query.toLowerCase();        
    return documentLinks.filter(el => el.Name.toLowerCase().indexOf(searchStr) > -1);
};

export default function UsefulDocuments({ documentLinks }) {
    const [searchQuery, setSearchQuery] = useState('');       

    const filteredDocs = filterUsefulDocuments(searchQuery, documentLinks);
    
    return (
        <>
            <div className='px-3 d-inline-block smart-panel-title'>
                <p className='mb-0'>
                    Suggested Links and Items
                    <OverlayTrigger
                        placement='top'
                        overlay={
                            <Tooltip>
                            Links to your most important links and suggested items. Please suggest more via the Feedback button.
                            </Tooltip>
                        }>
                        <i className='far fa-question-circle tooltip-icon'></i>
                    </OverlayTrigger>
                </p>
                <span>Documents to help you get things done</span>
                <input className='form-control namespace-input w-100 m-0' type='text' placeholder='Search...' value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </div>               
            
            <div>
                {filteredDocs.map((items, index) =>
                    <a key={index}
                        className='d-flex suggested-item'
                        href={items.Url}
                        rel='noreferrer'
                        target='_blank'                       
                    >
                        <i className='fab fa-confluence'></i>
                        <div style={{width : '70%'}}>
                            <span>{items.Name}</span>
                        </div>
                    </a>
                )}
            </div>
           
        </>
    );
}